import script from "./InfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./InfoModal.vue?vue&type=style&index=0&id=2d65bf70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d65bf70"]])

export default __exports__